import LogoMarquee from "./LogoMarquee";
import { INDUSTRY_EXPERIENCE } from "../data/content";
import { useLang } from "../i18n";

// Industry environments our team and partner network have worked in.
// Deliberately worded as experience — never as clients or endorsements.
export const IndustryRibbon = ({ index = "" }) => {
  const { t } = useLang();
  const c = t.industryExperience;
  return (
    <LogoMarquee
      items={INDUSTRY_EXPERIENCE}
      testId="industry-ribbon"
      plateId="industry-plate"
      index={index}
      label={c.label}
      title={c.title}
      lead={c.lead}
      note={c.note}
      meta="sector"
    />
  );
};

export default IndustryRibbon;
